import {setupModal} from '../utils/modal';

const modals = document.querySelectorAll('.modal');
const modalFeedback = document.querySelector('.modal--feedback');
const modalFeedbackBtns = document.querySelectorAll('[data-modal="feedback"]');
const modalSuccess = document.querySelector('.modal--success');
const modalSuccessBtns = document.querySelectorAll('[data-modal="success"]');
const modalTast1 = document.querySelector('.modal--mandarink');
const modalTast1Btns = document.querySelectorAll('[data-modal="mandarink"]');
const modalTast2 = document.querySelector('.modal--lime');
const modalTast2Btns = document.querySelectorAll('[data-modal="lime"]');
const modalTast3 = document.querySelector('.modal--granate');
const modalTast3Btns = document.querySelectorAll('[data-modal="granate"]');
const modalTast4 = document.querySelector('.modal--top');
const modalTast4Btns = document.querySelectorAll('[data-modal="top"]');
const modalTast5 = document.querySelector('.modal--fresh');
const modalTast5Btns = document.querySelectorAll('[data-modal="fresh"]');
const modalTast6 = document.querySelector('.modal--cherry');
const modalTast6Btns = document.querySelectorAll('[data-modal="cherry"]');
const modalTast7 = document.querySelector('.modal--zero');
const modalTast7Btns = document.querySelectorAll('[data-modal="zero"]');
const modalQuestion = document.querySelector('.modal--question');
const modalQuestionBtns = document.querySelectorAll('[data-modal="question"]');
const modalUser = document.querySelector('.modal--user');
const modalUserBtns = document.querySelectorAll('[data-modal="user"]');
const modalSms = document.querySelector('.modal--sms');
const modalSmsBtns = document.querySelectorAll('[data-modal="sms"]');
const modalBlocked = document.querySelector('.modal--blocked');
const modalBlockedBtns = document.querySelectorAll('[data-modal="blocked"]');


// аргументы setupModal(modal, closeCallback, modalBtns, openCallback, noPrevDefault, preventScrollLock)
// возможна инициализация только с первыми аргументом,
// если вам нужно открывать модалку в другом месте под какими-нибудь условиями
const initModals = () => {
  // фикс для редких случаев, когда модалка появляется при загрузке страницы
  window.addEventListener('load', () => {
    if (modals.length) {
      modals.forEach((el) => {
        setTimeout(() => {
          el.classList.remove('modal--preload');
        }, 100);
      });
    }
  });

  if (modalFeedback && modalFeedbackBtns.length) {
    setupModal(modalFeedback, false, modalFeedbackBtns, false, false);
  }
  if (modalSuccess && modalSuccessBtns.length) {
    setupModal(modalSuccess, false, modalSuccessBtns);
  }
  if (modalTast1 && modalTast1Btns.length) {
    setupModal(modalTast1, false, modalTast1Btns);
  }
  if (modalTast2 && modalTast2Btns.length) {
    setupModal(modalTast2, false, modalTast2Btns);
  }
  if (modalTast3 && modalTast3Btns.length) {
    setupModal(modalTast3, false, modalTast3Btns);
  }
  if (modalTast4 && modalTast4Btns.length) {
    setupModal(modalTast4, false, modalTast4Btns);
  }
  if (modalTast5 && modalTast5Btns.length) {
    setupModal(modalTast5, false, modalTast5Btns);
  }
  if (modalTast6 && modalTast6Btns.length) {
    setupModal(modalTast6, false, modalTast6Btns);
  }
  if (modalTast7 && modalTast7Btns.length) {
    setupModal(modalTast7, false, modalTast7Btns);
  }
  if (modalQuestion && modalQuestionBtns.length) {
    setupModal(modalQuestion, false, modalQuestionBtns);
  }
  if (modalUser && modalUserBtns.length) {
    setupModal(modalUser, false, modalUserBtns);
  }
  if (modalSms && modalSmsBtns.length) {
    setupModal(modalSms, false, modalSmsBtns);
  }
  if (modalBlocked && modalBlockedBtns.length) {
    setupModal(modalBlocked, false, modalBlockedBtns);
  }
};

export {initModals};
